import React, {Component} from 'react';
import {Toast} from 'antd-mobile';
import OrderShunt from '../../../../../../components/OrderShunt';
import {connect} from "react-redux";

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Before extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalData: {},
            dataList: [],
            type:0,//0是出发，1是到达
        };
    }

    componentDidMount() {
        // Toast.loading('正在加载', 0);
        // let params = {
        //     token: this.props.userInfo.token,
        //     "data": {
        //         "billType":0,
        //         "operatorType":1,
        //     }
        // };
        // getbillofdriver(params).then((res) => {
        //     Toast.hide();
        //     if (res.data.code === '0000') {
        //         this.setState({
        //             totalData: res.data.data,
        //         });
        //     }
        // }).catch(function (error) {
        //     console.log(error);
        // });
    }
    goPage = (k) =>{
        console.log(k)
        this.props.history.push(k)
    }
  
    render() {
        return (
            <OrderShunt 
                goPage={this.goPage.bind(this)}
                {...this.state}
                {...this.props}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/changeRole/Shunt/shuntOrder/startShunt/index.js